<div *ngIf="[gradeStatementScenarioType.gradeScenarioTypeGD, gradeStatementScenarioType.gdGradeScenarioInitialGrade.statement, gradeStatementScenarioType.incompleteScenarioBeforeFirstSubmitGrade.statement].indexOf(gradeStatement.gradeStatementText.gradeStatementScenarioType) >= 0"
     [innerHTML]="gradeStatement.gradeStatementText.displayText"></div>

<div *ngIf="[gradeStatementScenarioType.gradeScenarioTypeGD, gradeStatementScenarioType.gdGradeScenarioInitialGrade.statement, gradeStatementScenarioType.incompleteScenarioBeforeFirstSubmitGrade.statement].indexOf(gradeStatement.gradeStatementText.gradeStatementScenarioType) < 0 ">
    <br>
    <br>
    Deadline for student to complete coursework:
    <span *ngIf="['F', 'NC'].indexOf(student.gradeBanner) >= 0">{{ student.shrtckgIncompleteExtDateLastForFOrNC | date: 'MM/dd/yyyy' }} </span>
    <span *ngIf="['F', 'NC'].indexOf(student.gradeBanner) < 0">{{ student.shrtckgIncompleteExtDate | date: 'MM/dd/yyyy' }} </span>
    <br>
    <br>
    <mat-radio-group [(ngModel)]="student.gradeResponse.gradeStatementOptionId" class="grade-statement-group">
        <div *ngFor="let element of gradeStatementOptions">
            <mat-radio-button *ngIf="element.displayAsOption" class="grade-statement-option-item"
                              [value]="element.id"><span class="format-display" [innerHTML]="element.statement"></span>
            </mat-radio-button>
            <div *ngIf="!element.displayAsOption" [innerHTML]="element.statement"></div>
        </div>


    </mat-radio-group>
</div>

<mat-checkbox [(ngModel)]="student.gradeResponse.agree" [checked]="student.gradeResponse.agree">
    I agree to the above statement.
</mat-checkbox>

